class ToasterController {
    public static $inject: string[] = [
        "$mdToast",
        "message",
        "values",
        "hideCloseButton"
    ];

    constructor(
        private $mdToast: ng.material.IToastService,
        public message,
        public values,
        public hideCloseButton
    ) {}

    public closeToast() {
        this.$mdToast.hide();
    }
}

angular
    .module("thor.core.toaster.controller", [])
    .controller("ToasterController", ToasterController);
